import api from './api';

export interface City {
  city_id: string;
  name: string;
  code: string;
  region: string;
  ordering: number;
  is_big_size: boolean;
}

export interface Ward {
  _id: string;
  name: string;
  name_alias?: string;
  code: string;
  ordering: number;
}

export interface District {
  district_id: string;
  name: string;
  code: string;
  city: string;
  ordering: number;
}

export const locationService = {
  listCities: async (): Promise<City[]> => {
    const { data } = await api.get('/locations/cities');
    return data?.data?.cities ?? data?.cities ?? [];
  },

  listDistrictsByCity: async (cityId: string): Promise<District[]> => {
    const { data } = await api.get(`/districts/city/${cityId}`);
    return data?.data ?? [];
  },

  listWardsByCity: async (cityId: string): Promise<Ward[]> => {
    const { data } = await api.get(`/locations/wards/${cityId}`);
    return data?.data?.wards ?? data?.wards ?? [];
  },
};
